import React, { useState, useEffect } from 'react';
import '../styling/forms.css';

const EquipmentForm = ({ category, onSubmit }) => {
  const [form, setForm] = useState({
    equipmentCategory: category,
    equipmentName: '',
    manufacturer: '',
    model: '',
    serialNumber: '',
    location: '',
    dateOfEvent: new Date().toISOString().split('T')[0],
    timeOfEvent: '',
    procedureImpacted: '',
    patientImpact: 'No',
    downtimeMinutes: '',
    issueType: '',
    description: '',
    actionTaken: '',
    vendorContacted: 'No',
    vendorTicket: '',
    requiresFollowUp: 'No'
  });

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const update = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  const submit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <div className="form-wrapper">
      <h1>{category}</h1>
      <form className="card-form" onSubmit={submit}>
        <label>
          Equipment Name
          <input name="equipmentName" value={form.equipmentName} onChange={update} required />
        </label>
        <label>
          Manufacturer
          <input name="manufacturer" value={form.manufacturer} onChange={update} />
        </label>
        <label>
          Model
          <input name="model" value={form.model} onChange={update} />
        </label>
        <label>
          Serial Number
          <input name="serialNumber" value={form.serialNumber} onChange={update} />
        </label>
        <label>
          Location/Operatory
          <input name="location" value={form.location} onChange={update} />
        </label>
        <label>
          Date of Event
          <input type="date" name="dateOfEvent" value={form.dateOfEvent} onChange={update} required />
        </label>
        <label>
          Time of Event
          <input type="time" name="timeOfEvent" value={form.timeOfEvent} onChange={update} />
        </label>
        <label>
          Procedure Impacted
          <input name="procedureImpacted" value={form.procedureImpacted} onChange={update} />
        </label>
        <label>
          Patient Impact
          <select name="patientImpact" value={form.patientImpact} onChange={update}>
            <option>No</option>
            <option>Yes</option>
          </select>
        </label>
        <label>
          Downtime (minutes)
          <input type="number" name="downtimeMinutes" value={form.downtimeMinutes} onChange={update} />
        </label>
        <label>
          Issue Type
          <select name="issueType" value={form.issueType} onChange={update}>
            <option value="">Select</option>
            <option>Hardware Failure</option>
            <option>Calibration/Accuracy</option>
            <option>Power/Network</option>
            <option>Consumable/Sterility</option>
            <option>User Error</option>
            <option>Other</option>
          </select>
        </label>
        <label>
          Description
          <textarea name="description" rows="5" value={form.description} onChange={update} required />
        </label>
        <label>
          Action Taken
          <textarea name="actionTaken" rows="4" value={form.actionTaken} onChange={update} />
        </label>
        <label>
          Vendor Contacted
          <select name="vendorContacted" value={form.vendorContacted} onChange={update}>
            <option>No</option>
            <option>Yes</option>
          </select>
        </label>
        <label>
          Vendor Ticket/Ref #
          <input name="vendorTicket" value={form.vendorTicket} onChange={update} />
        </label>
        <label>
          Requires Follow-up
          <select name="requiresFollowUp" value={form.requiresFollowUp} onChange={update}>
            <option>No</option>
            <option>Yes</option>
          </select>
        </label>
        <div className="actions">
          <button type="submit" className="primary">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default EquipmentForm;


